<template>
    <div class="no-pdl" v-bind:style="{color: model.hasRefundLimitTime?'inherit':'#999'}">
        <label for="refundLimitTime">
            <input id="refundLimitTime" type="checkbox" name="refundLimitTime" v-model="model.hasRefundLimitTime" :value="true">
            限制每日
        </label>
        <v-select :disabled="!model.hasRefundLimitTime" class="nano-select inline-input" v-model="model.refundLimitHourFrom" placeholder="请选择">
            <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
            </v-option>
        </v-select>
        点
        <v-select :disabled="!model.hasRefundLimitTime" class="nano-select inline-input" v-model="model.refundLimitMinuteFrom" placeholder="请选择">
            <v-option v-for="n in 60" :label="n-1<10?'0'+(n-1).toString():n-1" :value="n-1" :key="n">
            </v-option>
        </v-select>
        至
        <v-select :disabled="!model.hasRefundLimitTime" class="nano-select inline-input" v-model="model.refundLimitHourTo" placeholder="请选择">
            <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
            </v-option>
        </v-select>
        点
        <v-select :disabled="!model.hasRefundLimitTime" class="nano-select inline-input" v-model="model.refundLimitMinuteTo" placeholder="请选择">
            <v-option v-for="n in 60" :label="n-1<10?'0'+(n-1).toString():n-1" :value="n-1" :key="n">
            </v-option>
        </v-select>可退
        <span v-show="validateErrors.has('tab3', 'model.refundLimitTime')" class="help is-danger">结束时间不能小于开始时间</span>
    </div>
</template>
<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        methods: {
            checkRefundLimitTime () {
                let hasErrors = false
                if (this.model.hasRefundLimitTime) {
                    if (this.model.refundLimitHourFrom > this.model.refundLimitHourTo) {
                        hasErrors = true
                    } else if (this.model.refundLimitHourFrom === this.model.refundLimitHourTo
                        && this.model.refundLimitMinuteFrom >= this.model.refundLimitMinuteTo) {
                        hasErrors = true
                    }
                }
                if (hasErrors) {
                    this.validateErrors.add('tab3', {
                        key: 0,
                        modelName: 'model.refundLimitTime',
                        showError: true,
                        rule: 'required'
                    })
                } else {
                    this.validateErrors.removeAll('tab3', 'model.refundLimitTime')
                }
            }
        },
        watch: {
            'model.refundLimitHourFrom': 'checkRefundLimitTime',
            'model.refundLimitMinuteFrom': 'checkRefundLimitTime',
            'model.refundLimitHourTo': 'checkRefundLimitTime',
            'model.refundLimitMinuteTo': 'checkRefundLimitTime',
            'model.hasRefundLimitTime': 'checkRefundLimitTime'
        }
    }
</script>



// WEBPACK FOOTER //
// refundLimitTime.vue?902a2bb6